var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social-media-slider full-width-section"},[_c('div',{attrs:{"data-crl8-container-id":_vm.crl8Container,"data-crl8-filter":_vm.crl8Filter}})])}
var staticRenderFns = []

export { render, staticRenderFns }